import React from "react";

const appLinks = [
  {
    href: "https://apps.apple.com/sk/app/steamo/id6761302275",
    icon: "fab fa-apple",
    label: "App Store",
    note: "iPhone",
  },
  {
    href: "https://play.google.com/store/apps/details?id=sk.furi.steamo&hl=en",
    icon: "fab fa-google-play",
    label: "Google Play",
    note: "Android",
  },
];

const SteamoAppLinks = ({ compact = false }) => (
  <div className={`steamo-app ${compact ? "steamo-app--compact" : ""}`}>
    <div className="steamo-app__intro">
      <span className="steamo-app__eyebrow">Mobilná aplikácia</span>
      <strong>STEAMO</strong>
      <span>Správa členstva, platby a klubové informácie v mobile.</span>
    </div>
    <div className="steamo-app__links" aria-label="Stiahnuť aplikáciu STEAMO">
      {appLinks.map((link) => (
        <a
          className="steamo-app__store"
          href={link.href}
          key={link.href}
          target="_blank"
          rel="noreferrer"
          aria-label={`Stiahnuť STEAMO v ${link.label}`}
        >
          <i className={link.icon} aria-hidden="true" />
          <span>
            <small>{link.note}</small>
            {link.label}
          </span>
        </a>
      ))}
    </div>
  </div>
);

export default SteamoAppLinks;
